import * as THREE from 'three';
import { ParticlesSystem } from "../components/ParticlesSystem";

const emitterConfigs = {
    dust: {
        count: 2000,
        particleScaleVariation: new THREE.Vector3(1, 1, 1),
        particleScaleSpeed: new THREE.Vector3(-0.2, -0.2, -0.2),
        particleTransSpeed: new THREE.Vector3(0, 0, 0),
        particleTransVariation: new THREE.Vector3(2, 2, 2),
    },
    fireplace: {
        count: 300,
        scaleSpeed: -0.2,
        particleScaleVariation: new THREE.Vector3(1, 1, 1),
        particleScaleSpeed: new THREE.Vector3(-0.2, -0.2, -0.2),
        particleTransSpeed: new THREE.Vector3(0, 0, 3),
        particleTransVariation: new THREE.Vector3(1, 1, 1),
        particleRotSpeed: new THREE.Vector3(2, .1, .1),
    },
    alcove: {
        count: 500,
        particleScaleVariation: new THREE.Vector3(1, 1, 1),
        particleScaleSpeed: new THREE.Vector3(-0.4, -0.4, -0.4),
        particleTransSpeed: new THREE.Vector3(-3, 0, 0),
        particleTransVariation: new THREE.Vector3(1, 1, 1),
        particleRotSpeed: new THREE.Vector3(2, .1, .1),
    },
    chandelier: {
        count: 500,
        particleScaleVariation: new THREE.Vector3(1, 1, 1),
        particleScaleSpeed: new THREE.Vector3(-0.4, -0.4, -0.4),
        particleTransSpeed: new THREE.Vector3(0, 0, 0),
        particleTransVariation: new THREE.Vector3(1, 1, 1),
        particleRotSpeed: new THREE.Vector3(2, .1, .1),
    },
    bb: {
        count: 500,
        particleScale: new THREE.Vector3(0.5, 0.5, 0.5),
        particleScaleVariation: new THREE.Vector3(1, 1, 1),
        particleScaleSpeed: new THREE.Vector3(-0.4, -0.4, -0.4),
        particleTransSpeed: new THREE.Vector3(3, 0, 0),
        particleTransVariation: new THREE.Vector3(1, 1, 1),
        particleRotSpeed: new THREE.Vector3(2, .1, .1),
    }
}

export class EmitterManager {
    constructor({ model, assets, scene }) {

        // Create mesh
        const dustGeom = new THREE.PlaneGeometry(0.4, 0.4)
        const dustMat = new THREE.MeshBasicMaterial({
            map: assets.textures.halo,
            side: THREE.DoubleSide,
            transparent: true,
            opacity: 0.2,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
        });

        const dustParticle = new THREE.Mesh(dustGeom, dustMat);

        const dustMat2 = dustMat.clone();
        dustMat2.opacity = 0.4;
        const dustParticle2 = new THREE.Mesh(dustGeom, dustMat2);

        this.systems = ["dust", "fireplace", "alcove", "chandelier", "bb"]
            .map(name => {
                const emitter = model.scene.getObjectByName(`${name}Emitter`);
                emitter.visible = false;
                return {
                    name,
                    emitter,
                };
            }).map(({ name, emitter }) => {
                const system = new ParticlesSystem({
                    ...emitterConfigs[name],
                    scene,
                    emitter,
                    particle: name === "bb" ? dustParticle2 : dustParticle,
                });

                system.createParticles();

                return system;
            });
    }

    update(deltaTime) {
        this.systems.forEach(s => s.updateParticles(deltaTime));
    }
}